module.exports = __webpack_public_path__ + "components/weather-icon/static/dayrainshowers@2-be0abdce0267ec949e0a9246d3063e35.png";